module.exports = __webpack_public_path__ + "static/chris-e130bdce758e5f79dfde5354f6a14e64.png";